<div class="wm-form"
  [ngClass]='{"disabled" : (liveWidgetSettings.activeTab.type === "fields" && (!liveWidgetSettings.selectedComponent.field.isGroup && !liveWidgetSettings.selectedComponent.field.pcDisplay &&  !liveWidgetSettings.selectedComponent.field.mobileDisplay)) ||
            (liveWidgetSettings.activeTab.type === "actions" && !liveWidgetSettings.selectedComponent.button.include)}'>
  <div class="dialog-form-section">
    <!--Security Type-->
    <div class="form-group app-composite-widget clearfix" *ngIf="liveWidgetSettings.isSecurityEnabled">
      <label class="col-md-3 control-label app-label">{{locale.LABEL_PROPERTY_SECURITYTYPE}}</label>
      <wms-role-selector class="form-control app-accessroles-select" [roles]="liveWidgetSettings.accessroles"
        *ngIf="liveWidgetSettings.activeTab.type === 'fields'" (onChange)="onModelChange($event)"
        [model]="liveWidgetSettings.selectedComponent.field.accessroles" [isProperty]="true"></wms-role-selector>
      <wms-role-selector class="form-control app-accessroles-select" [roles]="liveWidgetSettings.accessroles"
        (onChange)="onModelChange($event)"
        *ngIf="liveWidgetSettings.activeTab.type === 'actions'"
        [model]="liveWidgetSettings.selectedComponent.button.accessroles" [isProperty]="true"></wms-role-selector>

      <i placement="right" [tooltipAppendToBody]="true" tooltip="{{locale.LABEL_PROPERTY_SECURITYTYPE}}"
        class="wms wms-help"></i>
    </div>
    <div class="panel-body" *ngIf="!liveWidgetSettings.isSecurityEnabled">
      <p>{{locale.MESSAGE_ENABLE_SECURITY}}</p>
    </div>
  </div>
</div>